import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { M_Table, BufferService } from "src/M_Components";

const BookingListNAIP = ({ roles, onCreateTab, toastMessages, tablesOrder = [], onTablesOrderUpdate }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [waiting, setWaiting] = useState("");
  const [waiting2, setWaiting2] = useState("");
  const [waiting3, setWaiting3] = useState("");

  const statusService = new BufferService("processStatus");

  const order = {
    columnName: "createdOnWithHours",
    orderBool: false,
  };

  useEffect(() => {
    statusService.get().then((res) => {
      if (res.name === "AxiosError") {
        toastMessages("error", res.message, "");
        return;
      }
      res.Items.forEach((obj) => {
        if (obj.StatusName === "Waiting for Approval") {
          setWaiting(obj.Id);
        }
        if (obj.StatusName === "Waiting for Approval (Changes)") {
          setWaiting2(obj.Id);
        }
        if (obj.StatusName === "Waiting for Approval (Cancel)") {
          setWaiting3(obj.Id);
        }
      });
    });
  }, []);

  const NewRoute = (url, label) => {
    let tempData = sessionStorage.getItem("lines");
    if (tempData === "undefined" || tempData === null) {
      toastMessages("error", "", t("SelectedLine"));
      return;
    }
    tempData = JSON.parse(tempData).pop();
    sessionStorage.removeItem("lines");

    if (tempData.BookingStatus === "Waiting for Approval (Cancel)") {
      navigate("go/viewBooking");
      onCreateTab("go/viewBooking", label + " " + tempData?.BookingNumber);
      sessionStorage.setItem("bookingLine", JSON.stringify(tempData));
      sessionStorage.setItem("operation", "Delete");
      return;
    }

    sessionStorage.setItem("approveBooking", JSON.stringify(tempData));
    navigate(`${url}`);
    onCreateTab(url, label + " " + tempData?.BookingNumber);
  };

  const NewRouteContext = (url, label) => {
    let tempData = sessionStorage.getItem("context");
    if (tempData === "undefined") {
      toastMessages("error", "", t("SelectedLine"));
      return;
    }
    tempData = JSON.parse(tempData);
    sessionStorage.removeItem("context");

    if (tempData.BookingStatus === "Waiting for Approval (Cancel)") {
      navigate("go/viewBooking");
      onCreateTab("go/viewBooking", label + " " + tempData?.BookingNumber);
      sessionStorage.setItem("bookingLine", JSON.stringify(tempData));
      sessionStorage.setItem("operation", "Delete");
      return;
    }

    sessionStorage.setItem("approveBooking", JSON.stringify(tempData));
    navigate(`${url}`);
    onCreateTab(url, label + " " + tempData?.BookingNumber);
  };

  const lineContextMenuBooking = [
    {
      label: t("CheckBooking"),
      icon: "pi pi-search",
      command: () => NewRouteContext("go/approveBooking", "Check Booking"),
    },
  ];

  const buttons = [
    {
      label: t("CheckBooking"),
      element: "default",
      source: "/icons/svgsDaNet/search.svg",
      style: {
        filter:
          "invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)",
      },
      command: () => NewRoute("go/approveBooking", "Check Booking"),
    },
  ];

  const removeContextItems = ["View", "Create", "Edit", "Print"];

  const getLineBooking = (e) => {
    if (e.length) {
      sessionStorage.setItem("lines", JSON.stringify(e));
    } else {
      sessionStorage.removeItem("lines");
    }
  };

  const getContextBooking = (e) => {
    if (e) {
      sessionStorage.setItem("context", JSON.stringify(e));
    } else {
      sessionStorage.removeItem("context");
    }
  };

  return waiting ? (
    <M_Table
      entityName={"booking"}
      rolePermissions={roles}
      tablesOrder={tablesOrder}
      onTablesOrderUpdate={onTablesOrderUpdate}
      pageUrl={'Approve Bookings'}
      lineContext={lineContextMenuBooking}
      removeContextItems={removeContextItems}
      extraButtons={buttons}
      onPassLine={getLineBooking}
      onPassContext={getContextBooking}
      FILTER={`(ProcessStatusId eq ${waiting} or ProcessStatusId eq ${waiting2} or ProcessStatusId eq ${waiting3})&orderby=createdOnWithHours asc`}
    />
  ) : (
    ""
  );
  // <Table entityName={'Approval/bookingswaiting'} rolePermissions={roles} lineContext={lineContextMenuBooking} removeContextItems={removeContextItems} extraButtons={buttons} />
};

export default BookingListNAIP;
